import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { AppliedChip } from './fundingFilters'
import { useStyles } from './AppliedFiltersBar.styles'

interface SortChip {
  label: string
  value: string
}

interface AppliedFiltersBarProps {
  sort: SortChip | null
  onClearSort: () => void
  filters: AppliedChip[]
  onDeleteFilter: (key: string) => void
  /** How many filter chips to show before collapsing the rest into "+N". */
  chipDisplayLimit?: number
}

export const AppliedFiltersBar = ({
  sort,
  onClearSort,
  filters,
  onDeleteFilter,
  chipDisplayLimit = 2,
}: AppliedFiltersBarProps) => {
  const { classes } = useStyles()

  if (!sort && filters.length === 0) return null

  const shown = filters.slice(0, chipDisplayLimit)
  const overflow = filters.length - shown.length

  const chip = (
    label: string,
    value: string,
    onDelete: () => void,
    key?: string
  ) => (
    <button
      key={key}
      type="button"
      className={classes.chip}
      onClick={onDelete}
      aria-label={`Remove ${label}: ${value}`}
    >
      <Typography component="span" className={classes.chipText}>
        {`${label}: `}
        <Typography component="span" className={classes.chipValue}>
          {value}
        </Typography>
      </Typography>
      <FontAwesomeIcon icon={faXmark} className={classes.chipIcon} />
    </button>
  )

  return (
    <div className={classes.bar} data-testid="funding-applied-filters">
      {sort && (
        <div className={classes.group}>
          <Typography component="span" className={classes.label}>
            Sorting applied:
          </Typography>
          {chip(sort.label, sort.value, onClearSort)}
        </div>
      )}
      {filters.length > 0 && (
        <div className={classes.group}>
          <Typography component="span" className={classes.label}>
            Filters applied:
          </Typography>
          {shown.map(filter =>
            chip(
              filter.label,
              filter.value,
              () => onDeleteFilter(filter.key),
              filter.key
            )
          )}
          {overflow > 0 && (
            <span className={classes.overflowChip}>
              <Typography component="span" className={classes.chipText}>
                {`+${overflow}`}
              </Typography>
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default AppliedFiltersBar
